import React, { PropTypes, Component } from 'react';

class ModalContainer extends Component {

    render() {
        const {
            actions,
            modal
        } = this.props;

        if (!modal.isModalOpen) {
            return null;
        }

        const data = modal.contextModal.data;
        const ModalType = modal.contextModal.type;
        const isModalOpen = modal.isModalOpen;

        return React.createElement(ModalType, { actions, data, isModalOpen: isModalOpen });
    }
}

ModalContainer.propTypes = {
    modal: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

export default ModalContainer;


// WEBPACK FOOTER //
// ./~/pluton-core/lib/containers/pages/service/Modal.container.js